import { NavBar } from "@/components/navigation/nav-bar";
import { SEO } from "@/components/seo/SEO";
import { getPersonStructuredData, getWebSiteStructuredData } from "@/utils/structured-data";
import { Home } from "@/sections/home";
import { HowIWork } from "@/sections/how-i-work";
// Backup — old video-based section, kept for rollback:
// import { CaseStudies } from "@/sections/case-studies";
import { CaseStudiesV2 } from "@/sections/case-studies-v2";
import { Skills } from "@/sections/skills";
import { AboutMe } from "@/sections/about-me";
import { Footer } from "@/sections/footer";
import { useSectionTracker } from "@/hooks/useSectionTracker";
import { useScrollToSectionOnMount } from "@/hooks/useScrollToSectionOnMount";

export function HomePage() {
  useSectionTracker();
  // Scroll to a section when arriving from a detail page's nav / back link.
  useScrollToSectionOnMount();

  // Combine structured data
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      getPersonStructuredData(),
      getWebSiteStructuredData()
    ]
  };

  return (
    <>
      <SEO 
        title="Stavros Symeonidis - Software Engineer & Data Engineering"
        description="Senior software engineer running a UK data-engineering practice. Multi-touch attribution, contribution-margin analytics, and NetSuite, Celigo, and EDI integration for DTC, CPG, and healthcare brands."
        url="https://www.stavrossymeonidis.dev"
        jsonLd={structuredData}
      />
      <div className="flex min-h-svh flex-col">
        <NavBar />
        <main className="w-full max-w-[1550px] mx-auto">
          <Home />
          <HowIWork />
          <CaseStudiesV2 />
          <Skills />
          <AboutMe />
          <Footer />
        </main>
      </div>
    </>
  );
}